import axios from '../axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/refresh', {
            withCredentials: true //truly important to send cookies
        });
        setAuth(prev => {
            console.log(JSON.stringify(prev));
            console.log(response.data.accessToken);
            return {
                ...prev,
                roles: response.data.roles,
                username: response.data.username,
                email: response.data.email,
                phone: response.data.phone,
                urlAvt: response.data.urlAvt,
                urlLogo: response.data.urlLogo,
                razonSocial: response.data.razonSocial,
                accessToken: response.data.accessToken,
                address: response.data.address
            }
        });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;

